<template>
  <div class="columns is-vcentered socials">
    <div class="column is-narrow ">
      <!-- <div class="columns" v-if="burgerOpen"> -->
      <transition-group
        tag="div"
        name="staggered-fade"
        :css="false"
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
        @appear="leave"
      >
        <div
          class="column is-narrow is-gapless list-item"
          v-for="(media, index) in socials"
          :data-index="index"
          :key="index - 1"
          v-show="burgerOpen"
        >
          <Social class="social" :media="media" />
        </div>
      </transition-group>
      <!-- </div> -->
    </div>
    <div class="column is-narrow">
      <Burger @click="test" class="burger" />
    </div>
  </div>
</template>

<script>
import Burger from "@/components/atoms/Burger.vue";
import Social from "@/components/atoms/Social.vue";
import Velocity from "velocity-animate";

export default {
  components: {
    Burger,
    Social,
  },
  methods: {
    test() {
      this.burgerOpen = !this.burgerOpen;
    },

    beforeEnter(el) {
      let spacing = el.dataset.index * el.clientWidth;
      el.style.opacity = 0;
      el.style.translateX = `${spacing}px`;
    },

    enter(el, done) {
      // let spacing = el.dataset.index  * 20;
      let delay = el.dataset.index * 100;
      setTimeout(() => {
        Velocity(el, { opacity: 1, translateX: `0px` }, { complete: done });
      }, delay);
    },

    leave(el, done) {
      let spacing = el.dataset.index * 20;
      let delay = el.dataset.index * 100;
      setTimeout(() => {
        Velocity(
          el,
          { opacity: 0, translateX: `${spacing}px` },
          { complete: done }
        );
      }, delay);
    },
  },
  data() {
    return {
      burgerOpen: false,
      socials: [
        {
          icon: "fab fa-youtube",
          link: "https://www.youtube.com/channel/UCMyG9qoEh2Yz3KLnCciZN-A",
          color: "#FF0000",
        },
        {
          icon: "fab fa-facebook",
          link: "https://www.facebook.com/mygymchecker/",
          color: "#1877F2",
        },
        {
          icon: "fab fa-linkedin",
          link: "https://www.linkedin.com/company/my-gym-checker",
          color: " #007BB5",
        },
        {
          icon: "fab fa-twitter",
          link: "https://twitter.com/Mygymchecker",
          color: "#1DA1F2",
        },
        {
          icon: "fab fa-instagram",
          link: "https://instagram.com/mygymchecker?r=nametag",
          color: "#C32AA3",
        },{
          icon: "fas fa-user-circle",
          link: process.env.VUE_APP_BASE_DASHBOARD_URL,
          color: "#00c5fd",
          style: "font-size: 90%"

        }
      ],
    };
  },
};
</script>

<style scoped>

.burger {
  z-index: 50;
}
.socials {
  height: 96px;
}

.list-item {
  display: inline-block;
}
</style>
